import "./SubsectionEdit.scss";
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Button,
  Tooltip,
  Icon,
  Input,
  Popconfirm,
} from "antd";
import { TableEdit, FieldSetEdit, ParagraphEdit, TextEdit, DecisionEdit } from '../'
import { useTranslation } from 'react-i18next';

const SubsectionEdit = ({ form, indexSection, section, component, subsection, lang, getComponentByType, getTooltipComponent, handleChangeValuesSection, isKycForm, getDecisionRiskTooltip, showDecisionRiskSelector }) => {
  const { t } = useTranslation();
  const [components, setComponents] = useState(["PARAGRAPH", "FIELDSET", "DECL", "TABLE", "DECISION", "TEXT"])
  
  useEffect(() => {
    if(component.type === 'DECISION') {
      setComponents(["PARAGRAPH", "FIELDSET", "TABLE", "TEXT"])
    }
  }, [])

  const handleClickComponent = (c) => {
    let subcomp = []
    subsection.components.map(c => {
      subcomp.push(c)
    })
    subcomp.push(getComponentByType(c, true))
    handlerChangeAttr('components', subcomp)
  }

  const deleteComponent = (index) => {
    let subcomp = subsection.components.filter((c,i) => index !== i)
    handlerChangeAttr('components', subcomp)
  }

    const handleChangeTitle = (value) => {
      let title = subsection.title??{}
      title[lang] = value
      handlerChangeAttr('title', title)
  }

  const handlerChangeAttr = (attr, value) => {
    subsection[attr] = value
    handleChangeValuesSection(section)
  }

  return (
    <div className="form-manager-subsection-edit">
      { component.type === 'SUBSECTION' &&
        <Row>
            <Col md={3} sm={4}>{t('forms.manager.section.subsectionTitle', {ns: 'forms'})}</Col>
            <Col span={8}>
              <Input value={subsection.title && subsection.title[lang]} onChange={(e) => handleChangeTitle(e.target.value)} size="small" />
            </Col>
        </Row>
      }
      <Row className="custom-tools">
        <ul className="custom-tools-group-menu">
        {components.map(c =>
          <li>
              <a href="#0" onClick={() => handleClickComponent(c)}>
                <span>
                  { c === "PARAGRAPH" && <><Icon type="align-center" />&nbsp;{t('forms.manager.section.tooltip.paragraph', {ns: 'forms'})}</>}
                  { c === "FIELDSET" && <><Icon type="form" />&nbsp;{t('forms.manager.section.tooltip.data', {ns: 'forms'})}</>}
                  { c === "TABLE" && <><Icon type="table" />&nbsp;{t('forms.manager.section.tooltip.table', {ns: 'forms'})}</>}
                  { c === "DECL" && <><Icon type="table" />&nbsp;{t('forms.manager.section.tooltip.declaration', {ns: 'forms'})}</>}
                  { c === "TEXT" && <><Icon type="edit" />&nbsp;{t('forms.manager.section.tooltip.text', {ns: 'forms'})}</>}
                  { c === "DECISION" && <><Icon type="fork" />&nbsp;{t('forms.manager.section.tooltip.decision', {ns: 'forms'})}</>}
                </span>
                <span>
                  <Tooltip title={t("forms.buttons.add", {ns: 'forms'})}>
                    <Icon type="plus"/>
                  </Tooltip>
                </span>
              </a>
          </li>
          )}
        </ul>
      </Row>

      <div className={'section-components section-type-'+section.type}>
        { subsection.components && subsection.components.map((comp, index) =>
          <Row className={'row-component-section row-' + comp.type}>
            <Row className="header-section-component-custom">
              <Col span={20}><strong>{indexSection ? ((indexSection+1)+'.'):null}{index+1}. {getTooltipComponent(comp.type)}</strong></Col>
              <Col span={4} className="tools-section-component-custom">
                { isKycForm && ['DECISION', 'DECL'].includes(comp.type) &&
                  <Tooltip title={getDecisionRiskTooltip(comp)} placement="bottom">
                    <Button data-risk-guide-target="decision-risk" size="small" icon="safety" onClick={() => showDecisionRiskSelector(comp)} />
                  </Tooltip>
                }
                <Tooltip title={t('forms.tooltip.deleteComponent', {ns: 'forms'})} placement="bottom">
                  <Popconfirm 
                    title={t('forms.popconfirm.deleteComponent', {ns: 'forms'})} 
                    onConfirm={(e) => deleteComponent(index)}
                    okText={t('messages.aml.modalAlert.yes')}
                    cancelText={t('messages.aml.modalAlert.no')}
                  >
                    <Button size="small" icon="delete" />
                  </Popconfirm>
                </Tooltip>
              </Col>
            </Row>

            { comp.type === 'PARAGRAPH' &&
              <ParagraphEdit form={form} section={section} component={comp} fieldset={comp.fieldSet} lang={lang} handleChangeValuesSection={handleChangeValuesSection}/>
            }
            { comp.type === 'FIELDSET' &&
              <FieldSetEdit form={form} section={section} component={comp} fieldset={comp} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
            }
            { (comp.type === 'TABLE' || comp.type === 'DECL') &&
              <TableEdit form={form} section={section} component={comp} fieldset={comp.fieldSet} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
            }
            { comp.type === 'TEXT' &&
              <TextEdit form={form} section={section} component={comp} lang={lang} handleChangeValuesSection={handleChangeValuesSection}/>
            }
            { comp.type === 'DECISION' &&
              <DecisionEdit form={form} section={section} component={comp} lang={lang}
                handleChangeValuesSection={handleChangeValuesSection}
                getComponentByType={getComponentByType} getTooltipComponent={getTooltipComponent}
                isKycForm={isKycForm} getDecisionRiskTooltip={getDecisionRiskTooltip}
                showDecisionRiskSelector={showDecisionRiskSelector}
              />
            }
          </Row>
        )}
      </div>
    </div>
  )
}

export default SubsectionEdit;
